import { defineMessages } from 'react-intl';

export default defineMessages({
  actionButtonPurchase: {
    defaultMessage: 'Purchase',
    id: 'actionButton.purchase',
  },
});
